import { default as FNS, logIn } from '../api';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';



export const fetch = createAsyncThunk('buses/fetch', async (payload, { dispatch }) => {
  try {
    const { id } = payload;
    
    const res = await FNS.getBus(id);
    dispatch(busesSlice.actions.addBus({ values: res }));
    
  } catch(e) {
    toast.error(e);
  }
});

export const fetchAll = createAsyncThunk('buses/fetchAll', async (payload, { dispatch }) => {
  try {

    const res = await FNS.getBuses();
    await dispatch(busesSlice.actions.replaceAll({ values: res }));
    
  } catch(e) {
    toast.error(e);
  }
});

export const ensureAll = createAsyncThunk('buses/ensureAll', async (payload, { dispatch, getState }) => {
  try {
    const state = getState();

    if(state.buses.haveAll) return;
    
    const res = await FNS.getBuses();
    dispatch(busesSlice.actions.replaceAll({ values: res }));
    
  } catch(e) {
    toast.error(e);
  }
});

export const ensure = createAsyncThunk('buses/ensure', async ({ id }, { dispatch, getState }) => {
  try {
    const state = getState();

    if(id in state.buses.knownBuses) return;
    
    const res = await FNS.getBus(id);
    dispatch(busesSlice.actions.addBus({ values: res }));
    
  } catch(e) {
    toast.error(e);
  }
});

export const update = createAsyncThunk('buses/update', async ({ id, name }, { dispatch }) => {
  try {

    const res = await FNS.updateBus(id, name);
    await dispatch(fetch({ id }));
    
  } catch(e) {
    toast.error(e);
  }
});

export const create = createAsyncThunk('buses/create', async ({ name }, { dispatch }) => {
  try {

    const res = await FNS.createBus(name);
    const { id } = res;
    await dispatch(fetch({ id }));
    return id;
    
  } catch(e) {
    toast.error(e);
  }
});

export const toggleBusHidden = createAsyncThunk('buses/toggleBusHidden', async ({ id, hidden }, { dispatch }) => {
  try {

    await FNS.toggleBusHidden(id, hidden);
    await dispatch(fetch({ id }));

  } catch(e) {
    toast.error(e);
  }
});


const busesSlice = createSlice({
  name: 'buses',
  initialState: {
    haveAll: false,
    knownBuses: {}
  },
  reducers: {
    replaceAll: (state, { payload: { values } }) => {
      state.haveAll = true;
      let newBuses = {};
      for(const bus of values) {
        newBuses[bus.bus_id] = bus;
      }
      state.knownBuses = newBuses;
    },
    addBus: (state, { payload: { values } }) => {
      for(const bus of values) {
        state.knownBuses[bus.bus_id] = bus;
      }
    }
  },
});

export default busesSlice.reducer;
